import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { useStore } from '../store/store';

/**
 * Keeps the profiler-demo search counter authoritative across in-app navigation.
 *
 * The counter (remaining demo searches) is read from AuthStore.userInfo, which is
 * only refetched from the BE on a full page bootstrap (getAccountDetails). Searches
 * reconcile the store on completion, but a credit can also be spent on a page that
 * does not show the counter (e.g. a comparables search on the company-details page).
 * When the user then navigates back — via an in-app "back" button or browser back —
 * no bootstrap runs, so the counter shows a stale value until an F5.
 *
 * Mirror what an F5 already does: refetch the counter from the BE on every in-app
 * navigation. Demo-gated, so it issues no request for any other account type.
 */
const useAppDemoCounterRefresh = () => {
  const { authStore, profilerAccessStore } = useStore();
  const location = useLocation();

  // Key on location.key (unique per history entry) rather than pathname so a
  // refresh fires on *every* navigation — including a back button that lands on
  // a path already visited — not only on cross-page transitions.
  useEffect(() => {
    if (profilerAccessStore.isProfilerDemo) {
      authStore.refreshProfilerDemoCounter();
    }
  }, [location.key, authStore, profilerAccessStore]);
};

export default useAppDemoCounterRefresh;
